import { pdf, invpdf } from './Math';
// To understand how the kernel is created follow this link
// https://www.desmos.com/calculator/61ycw933mp
export const createKernel = (variance, sampleNumber) => {
    // Provides default values if
    if (variance <= 0) {
        variance = 10;
    }
    if (sampleNumber <= 1) {
        sampleNumber = 10;
    }
    // Sets final point to 0.01 as less then 1% has almost no weighing
    const finalValue = invpdf(variance, 0, 0.01);
    const sampleWidth = finalValue / (sampleNumber - 1);
    const kernel = [];
    for (let i = 0; i < sampleNumber; i++) {
        kernel[i] = pdf(variance, 0, sampleWidth * i);
    }
    return kernel;
};
// Creates a gaussian convolution filter where the variance and number of samples
// to smooth must be specified
export class Filter {
    constructor(variance, sampleNumber) {
        this.points = [];
        this.kernel = createKernel(variance, sampleNumber);
        this.sampleNumber = sampleNumber;
        this.netKernelSum = this.kernel.reduce((a, b) => a + b);
    }
    // Adds a new point to the points array. Pops off the last point if the array
    // exceeds the max size
    addPoint(point) {
        if (this.points.length === this.sampleNumber) {
            this.points.pop();
        }
        this.points.unshift(point);
        // Preforms the convolution by multiplying the kernel values with the
        // available points
        const pointsSum = this.points.reduce((a, c, i) => a + c * this.kernel[i], 0);
        // Sums the portion of the kernel that is currently being used. If all points are being used
        // ( majority of the time) it uses the precomputed sum to save computation
        let kernelSum;
        if (this.points.length === this.sampleNumber) {
            kernelSum = this.netKernelSum;
        }
        else {
            kernelSum = this.kernel.slice(0, this.points.length).reduce((a, b) => a + b);
        }
        const newFilteredPoint = pointsSum / kernelSum;
        this.points[0] = newFilteredPoint;
    }
    // Resets the points array
    resetPoints() {
        this.points = [];
    }
    // Returns the list of stored smooth points
    get allPoints() {
        return this.points;
    }
    // Returns the newest smoothed point
    get newestPoint() {
        return this.points[0];
    }
}
